/* @flow weak */
import escapeStringRegexp from 'escape-string-regexp';

/**
 * Generate a RegEx that matches any of the strings in the argument array.
 * @param  {String[]} stringList strings to match
 * @return {RegExp}
 */
export default function matchStrings(stringList) {
  return stringList.map(x => escapeStringRegexp(x)).join('|');
}
